import api from '../../utils/api';
import { BloodBankProfile } from '../../models/MasterAdmin/bloodBank';
import { BloodBankBookingsResponse } from '../../models/MasterAdmin/bloodBankBooking';

export const fetchBloodBankProfile = async (vendorId: string): Promise<BloodBankProfile> => {
  try {
    const response = await api.get(`/master-admin/bloodbank/vendor/${vendorId}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching blood bank profile:', error);
    throw error;
  }
};

export const fetchBloodBankBookings = async (vendorId: string): Promise<BloodBankBookingsResponse> => {
  try {
    const response = await api.get(`/master-admin/bloodbank/${vendorId}/bookings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blood bank bookings:', error);
    throw error;
  }
}; 